export var en = {
    required: 'Required',
    deprecated: 'Deprecated',
    deprecated_and_sunset_on: 'This operation is deprecated and will be sunset on ${1}.',
    stability_experimental: 'Experimental',
    stability_alpha: 'Alpha',
    stability_beta: 'Beta',
    copy_to_clipboard: 'Copy to clipboard',
    copied: 'Copied',
    no_content: 'No content',
    unresolved_reference: 'Unresolved reference',
    circular_reference: 'Circular reference',
    read_only: 'Read-only',
    write_only: 'Write-only',
    optional: 'Optional',
    min: 'Min',
    max: 'Max',
    nullable: 'Nullable',
    body: 'Body',
    payload: 'Payload',
    headers: 'Headers',
    authorizations: 'Authorizations',
    responses: 'Responses',
    path_parameters: 'Path parameters',
    query_parameters: 'Query parameters',
    header_parameters: 'Header parameters',
    attributes: 'Attributes',
    test_it: 'Test it',
    information: 'Information',
    success: 'Success',
    redirect: 'Redirect',
    error: 'Error',
    show: 'Show',
    hide: 'Hide',
    available_items: 'Available items',
    child_attributes: 'Child attributes',
};
